function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { CtaCard as DesignSystemCtaCard, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
var HouseIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-suburb-stats/static/house-icon_974eba5a.svg";
import * as styles from './cta-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CtaCard = _ref => {
  var appearance = _ref.appearance,
    suburbName = _ref.suburbName,
    suburbInfoLink = _ref.suburbInfoLink,
    onViewMoreInfoClick = _ref.onViewMoreInfoClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibilityEventSent = _useState2[0],
    setVisibilityEventSent = _useState2[1];
  var onCtaClick = () => {
    onViewMoreInfoClick();
    sendEvent('click-research-cta');
  };
  return ___EmotionJSX(VisibilitySensor, {
    onChange: isVisible => {
      if (isVisible && !visibilityEventSent) {
        sendEvent('display-research-cta');
        setVisibilityEventSent(true);
      }
    }
  }, ___EmotionJSX(DesignSystemCtaCard, {
    appearance: appearance,
    startElement: ___EmotionJSX("img", {
      src: HouseIcon,
      alt: ""
    }),
    title: "".concat(suburbName, "'s sales history & suburb profile"),
    subtitle: "Easy. Search over 37 million records for past sales, suburb details",
    endElement: ___EmotionJSX(LinkButton, {
      css: styles.button(appearance),
      appearance: "outline",
      href: suburbInfoLink,
      onClick: onCtaClick
    }, "Explore suburb profile")
  }));
};
CtaCard.propTypes = {
  appearance: PropTypes.oneOf(['horizontal', 'vertical']),
  suburbName: PropTypes.string,
  suburbInfoLink: PropTypes.string,
  onViewMoreInfoClick: PropTypes.func
};
CtaCard.defaultProps = {
  appearance: 'horizontal',
  suburbName: '',
  suburbInfoLink: null,
  onViewMoreInfoClick: () => {}
};
export default CtaCard;